import { createContext } from 'react';

type LoadingContext = {
	isEnable: boolean;
	enable: () => void;
	disable: () => void;
};

const LoadingContext = createContext<LoadingContext>(null!);

export default LoadingContext;
